const ca_vaillant = {
  WELCOME_TO_NEMURU: "Benvingut/benvinguda",
};

export default ca_vaillant;
